import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum Fases {
  PropostasPendentes = 'PropostasPendentes',
  AguardandoProposta = 'AguardandoProposta',
  AceitasValidandoDocumentos = 'AceitasValidandoDocumentos',
  AceitasEnvioDeDocumentos = 'AceitasEnvioDeDocumentos',
  Negociacao = 'Negociacao',
  NegociacaoParceiro = 'NegociacaoParceiro',
  Vencidas = 'Vencidas',
  DisponibilidadeDeLeads = 'DisponibilidadeDeLeads',
  AguardandoIntegracao = 'AguardandoIntegracao',
  Pagas = 'Pagas',
  Aprovadas = 'Aprovadas',
  Reprovadas = 'Reprovadas',
  Todas = 'Todas' 
}

export class FasesEnum extends GenericoTipoEnum<Fases> {
  static readonly PropostasPendentes = new FasesEnum(Fases.PropostasPendentes, 'Propostas pendentes');
  static readonly AguardandoProposta = new FasesEnum(Fases.AguardandoProposta, 'Aguardando proposta');
  static readonly AceitasValidandoDocumentos = new FasesEnum(Fases.AceitasValidandoDocumentos, 'Documentos aguardando PJUS');
  static readonly AceitasEnvioDeDocumentos = new FasesEnum(Fases.AceitasEnvioDeDocumentos, 'Documentos aguardando parceiro');
  static readonly Negociacao = new FasesEnum(Fases.Negociacao, 'Negociação');
  static readonly NegociacaoParceiro = new FasesEnum(Fases.NegociacaoParceiro, 'Negociação com parceiro');
  static readonly Vencidas = new FasesEnum(Fases.Vencidas, 'Vencidas');
  static readonly DisponibilidadeDeLeads = new FasesEnum(Fases.DisponibilidadeDeLeads, 'Disponibilidade de leads');
  static readonly AguardandoIntegracao = new FasesEnum(Fases.AguardandoIntegracao, 'Operação em andamento');
  static readonly Pagas = new FasesEnum(Fases.Pagas, 'Pagas');
  static readonly Aprovadas = new FasesEnum(Fases.Aprovadas, 'Aprovadas');
  static readonly Reprovadas = new FasesEnum(Fases.Reprovadas, 'Reprovadas');
  static readonly Todas = new FasesEnum(Fases.Todas, 'Todas');
}
